import React, { useState } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import NumberFormat from 'react-number-format';
import Switch from 'react-switch';
import Button from '../../../shared/components/Button/Button';
import './CouponForm.css';

const emptyCoupon = { code: '', discount: null, type: 'product', enabled: true };

const CouponForm = ({ initialCoupon, onSubmit, onCancel, saving }) => {
  const [coupon, setCoupon] = useState(initialCoupon || emptyCoupon);
  const [touched, setTouched] = useState(false);

  const isValid = Boolean(coupon.code) && Boolean(coupon.discount);

  const handleSubmit = (e) => {
    e.preventDefault();
    setTouched(true);
    if (!isValid) return;
    onSubmit({ ...coupon, code: coupon.code.toUpperCase() });
  };

  return (
    <form onSubmit={handleSubmit} className="coupon-form">
      <FormGroup>
        <Label>Código do cupom</Label>
        <Input
          type="text"
          placeholder="Ex: BLACKFRIDAY"
          value={coupon.code || ''}
          onChange={(e) => setCoupon({ ...coupon, code: e.target.value })}
        />
        {touched && !coupon.code && <small className="coupon-form__error">Campo obrigatório</small>}
      </FormGroup>

      <FormGroup>
        <Label>Tipo de cupom</Label>
        <div className="coupon-form__type-options">
          <button
            type="button"
            className={`coupon-form__type-btn ${coupon.type === 'product' ? 'is-active' : ''}`}
            onClick={() => setCoupon({ ...coupon, type: 'product' })}
          >
            Desconto em produto
          </button>
          <button
            type="button"
            className={`coupon-form__type-btn ${coupon.type === 'delivery' ? 'is-active' : ''}`}
            onClick={() => setCoupon({ ...coupon, type: 'delivery' })}
          >
            Desconto no frete
          </button>
        </div>
      </FormGroup>

      <FormGroup>
        <Label>Valor do desconto</Label>
        <NumberFormat
          suffix="%"
          className="form-control"
          placeholder="Valor do desconto em %"
          value={coupon.discount ?? ''}
          onValueChange={({ floatValue }) => setCoupon({ ...coupon, discount: floatValue ?? null })}
        />
        {touched && !coupon.discount && <small className="coupon-form__error">Campo obrigatório</small>}
      </FormGroup>

      <FormGroup className="coupon-form__enabled-row">
        <Label className="mb-0 mr-2">Cupom ativo</Label>
        <Switch
          checked={Boolean(coupon.enabled)}
          onChange={(checked) => setCoupon({ ...coupon, enabled: checked })}
          onColor="#86d3ff"
          onHandleColor="#2693e6"
          handleDiameter={18}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 7px rgba(0, 0, 0, 0.2)"
          height={12}
          width={28}
        />
      </FormGroup>

      <div className="coupon-form__actions">
        <Button variant="secondary" onClick={onCancel} disabled={saving}>
          Cancelar
        </Button>
        <Button variant="primary" type="submit" disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar'}
        </Button>
      </div>
    </form>
  );
};

export default CouponForm;
